import { render, staticRenderFns } from "./CKKanban.vue?vue&type=template&id=cbe3912c&scoped=true"
import script from "./CKKanban.vue?vue&type=script&lang=js"
export * from "./CKKanban.vue?vue&type=script&lang=js"
import style0 from "./CKKanban.vue?vue&type=style&index=0&id=cbe3912c&prod&lang=css"
import style1 from "./CKKanban.vue?vue&type=style&index=1&id=cbe3912c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe3912c",
  null
  
)

export default component.exports